import React from 'react';
import { CountdownTimer } from './CountdownTimer';
import { CTAButton } from './CTAButton';
import { Lock, Package, Shield } from 'lucide-react';
export function UrgencyCloseSection() {
  return <section className="bg-black py-24 px-4 border-t-4 border-neon" data-id="element-488">
      <div className="max-w-3xl mx-auto text-center" data-id="element-489">
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-neon leading-tight mb-12 font-montserrat" data-id="element-490">
          "Esta Oportunidad No Va a Estar Aquí Para Siempre"
        </h2>

        <div className="text-lg md:text-xl text-gray-300 space-y-6 mb-16 max-w-2xl mx-auto text-left" data-id="element-491">
          <p data-id="element-492">
            El mercado UGC en España está en su punto de mayor crecimiento y
            menor saturación ahora mismo.
          </p>
          <p data-id="element-493">
            En 2-3 años, cuando la práctica esté generalizada, los precios
            habrán bajado y la competencia habrá aumentado.
          </p>
          <p className="font-bold text-white" data-id="element-494">
            Cada día que esperas es un día que otra persona está construyendo su
            portfolio, consiguiendo sus primeros clientes y posicionándose en el
            mercado.
          </p>
          <p data-id="element-495">
            El precio de lanzamiento de{' '}
            <strong className="text-neon text-2xl" data-id="element-496">17.99€</strong> no va a
            durar.
          </p>
          <p data-id="element-497">No porque sea una táctica de presión barata.</p>
          <p data-id="element-498">
            Sino porque este precio solo tiene sentido durante el período de
            lanzamiento para conseguir los primeros testimonios reales.
          </p>
        </div>

        <div className="bg-neon rounded-3xl border-4 border-white p-8 md:p-12 shadow-neon-lg relative mb-16 max-w-xl mx-auto" data-id="element-499">
          <h3 className="text-2xl md:text-3xl font-black text-black text-center mb-8 tracking-tight border-b-4 border-black pb-4" data-id="element-500">
            ⏰ ESTA OFERTA EXPIRA EN:
          </h3>

          <div className="flex justify-center mb-4" data-id="element-501">
            <CountdownTimer showLabels={true} className="text-black" data-id="element-502" />
          </div>
        </div>

        <div className="max-w-2xl mx-auto" data-id="element-503">
          <CTAButton className="mb-8" data-id="element-504" />

          <div className="flex flex-col md:flex-row items-center justify-center gap-6 text-gray-400 font-medium" data-id="element-505">
            <div className="flex items-center gap-2" data-id="element-506">
              <Lock className="w-5 h-5" data-id="element-507" />
              <span data-id="element-508">Pago Seguro</span>
            </div>
            <div className="hidden md:block w-1 h-1 bg-gray-600 rounded-full" data-id="element-509"></div>
            <div className="flex items-center gap-2" data-id="element-510">
              <Package className="w-5 h-5" data-id="element-511" />
              <span data-id="element-512">Acceso Inmediato</span>
            </div>
            <div className="hidden md:block w-1 h-1 bg-gray-600 rounded-full" data-id="element-513"></div>
            <div className="flex items-center gap-2" data-id="element-514">
              <Shield className="w-5 h-5" data-id="element-515" />
              <span data-id="element-516">Garantía 30 Días</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}